import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Sizes from '../definitions/Sizes';
import Colours from '../definitions/Colours';


function HorizontalGaugeBlock({ level, title, caption, ...otherProps }) {
    return (
        <MyBottomMarginContainer {...otherProps}>
            <h4 className={'rh-title-2xs rh-mt-0 rh-mb-0_25'}>
                {title}
            </h4>

            <div className="horizontal-gauge rh-mp-0_25">
                <MyGauge
                    className="rh-m-0 rh-pl-0"
                    level={level}
                >
                    <li key={0} />
                    <li key={1} />
                    <li key={2} />
                </MyGauge>
                <p className="level-name rh-text-xs weight-bold rh-my-0 rh-ml-0_5">
                    <Choose>
                        <When condition={level === HorizontalGaugeLevels.LOW}>
                            <FormattedMessage
                                id="base-ui.gauge.low"
                                defaultMessage="LOW"
                            />
                        </When>
                        <When condition={level === HorizontalGaugeLevels.MEDIUM}>
                            <FormattedMessage
                                id="base-ui.gauge.medium"
                                defaultMessage="MEDIUM"
                            />
                        </When>
                        <When condition={level === HorizontalGaugeLevels.HIGH}>
                            <FormattedMessage
                                id="base-ui.gauge.high"
                                defaultMessage="HIGH"
                            />
                        </When>
                    </Choose>
                </p>
            </div>

            <If condition={caption}>
                <p className={'rh-text-s rh-m-0'}>
                    {caption}
                </p>
            </If>
        </MyBottomMarginContainer>
    );
}

const HorizontalGaugeLevels = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
};

HorizontalGaugeBlock.propTypes = {
    level: PropTypes.oneOf(Object.values(HorizontalGaugeLevels)).isRequired,
    title: PropTypes.node.isRequired,
    caption: PropTypes.node,
};


const BAR_COLOURS = {
    [HorizontalGaugeLevels.LOW]:    [ Colours.TANGERINE, Colours.STONE, Colours.STONE ],
    [HorizontalGaugeLevels.MEDIUM]: [ Colours.YUZU, Colours.YUZU, Colours.STONE ],
    [HorizontalGaugeLevels.HIGH]:   [ Colours.LIME, Colours.LIME, Colours.LIME ],
};

const MyBottomMarginContainer = styled.div`
    margin-bottom: ${Sizes.SPACING.ONE_AND_A_HALF};

    > .horizontal-gauge {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .level-name {
        flex-basis: ${Sizes.SPACING.FIVE};
        color: ${Colours.STONE_DARKEST};
    }
`;


const MyGauge = styled.ul`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    font-size: 0;
    list-style-type: none;

    li {
        margin-right: ${Sizes.SPACING.QUARTER};
        height: 6px;
        border-radius: 4px;
        width: 33%;

        &:first-child {
            background-color: ${props => BAR_COLOURS[props.level][0]};
        }

        &:nth-child(2) {
            background-color: ${props => BAR_COLOURS[props.level][1]};
        }

        &:nth-child(3) {
            background-color: ${props => BAR_COLOURS[props.level][2]};
        }
    }
`;



export { HorizontalGaugeLevels };
export default HorizontalGaugeBlock;
